// swiper実行
// --- 最新のswiper v11ではループ時の不具合があるため、あえてv8を使用
document.addEventListener('DOMContentLoaded', function () {
  const swiper_thumb = new Swiper('.js-swiper-thumb', {
    slidesPerView: 5,
    spaceBetween: 6,
    freeMode: true,
    slideToClickedSlide: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,

    breakpoints: {
      769: {
        spaceBetween: 10,
      },
    },
  });

  const swiper_main = new Swiper('.js-swiper-main', {
    speed: 1000,
    // autoplay: {
    //   delay: 3000,
    //   disableOnInteraction: false,
    // },
    slidesPerView: 1,
    loop: true,
    loopedSlides: 6,
    centeredSlides: true,
    navigation: {
      nextEl: '.js-swiper .c-article__slider__button.--next',
      prevEl: '.js-swiper .c-article__slider__button.--prev',
    },
    thumbs: {
      swiper: swiper_thumb,
    },
  });
});